import { initialState as passwordState, reducer as passwordReducer } from '@aarhus-university/au-lib-react-components/src/components/password/AUPasswordReducer';
import { GET_CONTEXT } from '../actions/const';

const initialState = {
  context: null,
};

const merge = (target, source) => {
  // https://gist.github.com/ahtcx/0cd94e62691f539160b32ecda18af3d6
  // eslint-disable-next-line no-restricted-syntax
  for (const key of Object.keys(source)) {
    if (source[key] instanceof Object) {
      Object.assign(source[key], merge(target[key], source[key]));
    }
  }

  Object.assign(target || {}, source);
  return target;
};

const reducer = (state = merge(initialState, passwordState), action) => {
  let nextState = passwordReducer({ ...state }, action);
  if (!nextState) {
    nextState = { ...state };
    switch (action.type) {
      case GET_CONTEXT: {
        if (action.result.context) {
          nextState.context = action.result.context;
        }
        return nextState;
      }
      default: {
        return state;
      }
    }
  }
  return nextState;
};

export default reducer;
